import Vue from 'vue';
import Vuex from 'vuex';
import tokenStorage from '@/helpers/tokenStorage';

// App Modules
// eslint-disable-next-line import/no-cycle
import Project from '../modules/project/store';
import Visit from '../modules/visit/store';
import AllSkus from '../modules/all-skus/store';
import Imageset from '../modules/imageset/store';
import StoreShow from '../modules/store-show/store';
import StoreWithVisits from '../modules/store-with-visits/store';
import StoreWithoutVisits from '../modules/store-without-visits/store';
import Auditor from '../modules/auditor/store';
import Account from '../modules/account/store';
import VisitReport from '../modules/visit-report/store';
import StockAvailabilityReports from '../modules/stock-availability/store';
import FacingReports from '../modules/facing-reports/store';
import GlobalFilters from '../modules/global-filters/store';
import SkuAvailability from '../modules/sku-availability/store';
import SkuFacingShares from '../modules/sku-facing-shares/store';
import Map from '../modules/map/store';
import Price from '../modules/price/store';

// Internal Modules
import Auth from '../modules/auth/store';

// Setup
Vue.use(Vuex);
const debug = process.env.NODE_ENV !== 'production';

export const storeOptions = {
  actions: {
    async setupApplication({ dispatch }) {
      try {
        if (tokenStorage.get()) {
          await dispatch('fetchAccount');
        }

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    }
  },
  modules: {
    Auth,
    Account,

    Project,
    AllSkus,
    SkuAvailability,
    SkuFacingShares,
    Visit,
    Imageset,
    StoreWithVisits,
    StoreWithoutVisits,
    StoreShow,
    Auditor,
    VisitReport,
    StockAvailabilityReports,
    FacingReports,
    Map,
    Price,

    GlobalFilters,
    Dashboards: {},
    DashboardsTabs: {}
  },
  strict: debug
};

export default new Vuex.Store(storeOptions);
